export const formatLongIsoDate = (dateString: string): string => {
  if (!dateString) {
    return '';
  }

  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return '';
  }

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };

  return new Intl.DateTimeFormat('en-US', options).format(date);
};

export const formatLongIsoDateOrDash = (
  dateString?: string | null
): string => {
  const formatted = dateString ? formatLongIsoDate(dateString) : '';
  return formatted || '—';
};
